import { Fragment, useEffect, useState } from 'react';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { EditButtonIcon } from 'src/component/Buttons/EditButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const EditVillage = (props) => {
  const httpClient = useHttpClient(true);
  const [UpdateModal, setUpdateModal] = useState(false);
  const[codeVillage,setCodeVillage]=useState('');
  const [villageData, setVillageData] = useState({});
  const [OpenAlert, setOpenAlert] = useState(false);
  const [OpenDangerAlert, setOpenDangerAlert] = useState(false);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [departements, setDepartements] = useState([]);
  const [communes, setCommunes] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState<any>();
  const [selectedRegion, setSelectedRegion] = useState<any>();
  const [selectedDepartement, setSelectedDepartement] = useState<any>();
  const [selectedCommune, setSelectedCommune] = useState<any>();
  const UpdateModalToggle = () => resetForm();
  const Toggle = () => setOpenAlert(!OpenAlert);
  const DangerAlertToggle = () => setOpenDangerAlert(!OpenDangerAlert);
  const [, setCountryValue] = useState('');
  const [spinner, setSpinner] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setVillageData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (villageData['name'] === '') {
        setOpenDangerAlert(true);
        const timer = setTimeout(() => {
          setOpenDangerAlert(false);
        }, 1500);
        villageData['name'] = props.village['name'];
        return () => clearTimeout(timer);
      } else {
        setSpinner(true);
        villageData['commune'] = JSON.parse(selectedCommune);
        const response = httpClient.current?.put(`/api/village/update`, villageData);
        if ((await response).status === 200) {
          setSpinner(false);
          props.villages();
          setUpdateModal(!UpdateModal);
        }
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    villageData['name'] = props.village['name'];
    setUpdateModal(!UpdateModal);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const villageId = props.village.id;
        const villageResponse = await httpClient.current?.get(`/api/village/${villageId}`);
        const village = villageResponse.data;
        setVillageData(village);
        setCodeVillage(village.code);
      } catch (error) {
        console.error('Error fetching village data:', error);
      }
    };

    fetchData();
  }, [props.village, httpClient]);
  useEffect(() => {
    setVillageData(props.village);
    setSelectedCountry(JSON.stringify(props.village['commune']['departement']['region']['country']));
    setSelectedRegion(JSON.stringify(props.village['commune']['departement']['region']));
    setSelectedDepartement(JSON.stringify(props.village['commune']['departement']));
    setSelectedCommune(JSON.stringify(props.village['commune']));
    setCodeVillage(props.village['code']); 
  }, [props.village]);
  useEffect(() => {
    const getCountries = () => {
      httpClient.current?.get(`/api/country/all`).then((response) => {
        setCountries(response.data);
      });
    };
    getCountries();
  }, [httpClient, selectedCountry]);

  useEffect(() => {
    const getRegions = () => {
      if (!selectedCountry) return;
      httpClient.current?.get(`/api/region/all`).then((response) => {
        let regions = response.data;
        regions = regions.filter((region) => region.country.id === JSON.parse(selectedCountry).id);
        setRegions(regions);
      });
    };
    getRegions();
  }, [selectedCountry]);
  useEffect(() => {
    const getDepartements = () => {
      httpClient.current?.get(`/api/departement/all`).then((response) => {
        setDepartements(response.data);
      });
    };
    getDepartements();
  }, [httpClient, selectedRegion]);
  useEffect(() => {
    const getCommunes = () => {
      if (!selectedDepartement) return;
      httpClient.current?.get(`/api/commune/all`).then((response) => {
        let communes = response.data;
        communes = communes.filter((commune) => commune.departement.id === JSON.parse(selectedDepartement).id);
        setCommunes(communes);
      });
    };
    getCommunes();
  }, [httpClient, selectedDepartement]);

  return (
    <>
      <EditButtonIcon
        title={props.t('update_village')}
        onClick={UpdateModalToggle}
        className={`fa fa-pencil ${styles['action']}`}
      />
      <Modal isOpen={UpdateModal} toggle={UpdateModalToggle} centered>
        <ModalHeader toggle={UpdateModalToggle}>{props.t('update_village')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={OpenAlert} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            <Alert className="alert-dismissible" color="danger dark" isOpen={OpenDangerAlert} target="Alert-2">
              <strong>{props.t('fill_out')}</strong>
              <Button className="close" color="default" id="Alert-2" onClick={DangerAlertToggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onChange={handleChange} onSubmit={handleSubmit}>
                <FormGroup className="form-row">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="name"
                    value={villageData['name']}
                    onChange={(event) => setCountryValue(event.target.value)}
                    placeholder={props.t('placeholder_village_name')}
                  />
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'village_code'}>{props.t('Code')}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="code"
                    id="code"
                    value={codeVillage}
                    onChange={(event) => setCodeVillage(event.target.value)}
                  
                  />
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor={'country_name'}>{props.t('country_name')}</label>
                  <select
                    name="country"
                    id="country"
                    className="form-control"
                    value={selectedCountry}
                    onChange={(e) => setSelectedCountry(e.target.value)}
                    placeholder={props.t('select_country_name')}
                  >
                    <option value="">{props.t('select_country_name')}</option>
                    {countries.map((country, index) => (
                      <option id={country.id} key={index} value={JSON.stringify(country)}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <FormGroup className={`form-row ${selectedCountry ? 's' : 'd-none'}`}>
                  <label htmlFor={'region_name'}>{props.t('region_name')}</label>
                  <select
                    name="region"
                    id="region"
                    className="form-control"
                    value={selectedRegion}
                    onChange={(e) => setSelectedRegion(e.target.value)}
                  >
                    <option value="">{props.t('select_region_name')}</option>

                    {regions.map((region, index) => (
                      <option id={region.id} key={index} value={JSON.stringify(region)}>
                        {region.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
                <FormGroup className={`form-row ${selectedRegion ? 's' : 'd-none'}`}>
                  <label htmlFor={'departement_name'}>{props.t('departement_name')}</label>
                  <select
                    name="departement"
                    id="departement"
                    className="form-control"
                    value={selectedDepartement}
                    onChange={(e) => setSelectedDepartement(e.target.value)}
                  >
                    <option value="">{props.t('select_departement_name')}</option>

                    {departements.map((dep, index) => (
                      <option id={dep.id} key={index} value={JSON.stringify(dep)}>
                        {dep.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
                <FormGroup className={`form-row ${selectedDepartement ? 's' : 'd-none'}`}>
                  <label htmlFor={'commune_name'}>{props.t('commune_name')}</label>
                  <select
                    name="commune"
                    id="commune"
                    className="form-control"
                    value={selectedCommune}
                    onChange={(e) => setSelectedCommune(e.target.value)}
                  >
                    <option value="">{props.t('select_commune_name')}</option>
                    {communes.map((com, index) => (
                      <option id={com.id} key={index} value={JSON.stringify(com)}>
                        {com.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('update')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={UpdateModalToggle}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(EditVillage);
